export default __webpack_public_path__ + "static/media/crow.03b5a5c7.png";